import { render, staticRenderFns } from "./CIconButton.vue?vue&type=template&id=318c82b7&scoped=true&"
import script from "./CIconButton.vue?vue&type=script&lang=js&"
export * from "./CIconButton.vue?vue&type=script&lang=js&"
import style0 from "./CIconButton.vue?vue&type=style&index=0&id=318c82b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318c82b7",
  null
  
)

export default component.exports